import { render, staticRenderFns } from "./TemplateEmail.vue?vue&type=template&id=79806448"
import script from "./TemplateEmail.vue?vue&type=script&lang=js"
export * from "./TemplateEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79806448')) {
      api.createRecord('79806448', component.options)
    } else {
      api.reload('79806448', component.options)
    }
    module.hot.accept("./TemplateEmail.vue?vue&type=template&id=79806448", function () {
      api.rerender('79806448', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/TemplateEmail.vue"
export default component.exports